import wb1 from "./assets/hero.png";
import wb2 from "./assets/newAbout.jpg";
import wb3 from "./assets/footer.webp";
import "./App.css";
import WhitelistInline from "./whitelist/WhitelistInline";

const App = () => {
  return (
    <>
      <div className="page">
        <img src={wb1} alt="" className="section-img1" />
        <div className="section-img-overlap">
          <img src={wb2} alt="" className="section-img" />
        </div>
      </div>
      <div className="form section-img-overlap">
        <WhitelistInline />
      </div>
      <div className="page">
        <img src={wb3} alt="" className="section-img section-img-overlap footer-img" />
      </div>
    </>
  );
};

export default App;